import React from 'react';
import PropTypes from 'prop-types';

import Media from 'reactstrap/lib/Media';

import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import isEqual from 'react-fast-compare';
import { map, filter, size } from 'lodash';

import ScrollArea from 'react-scrollbar';
import ScrollAreaButtons from '../../UI/ScrollAreaButtons';

import coinImg from '../../../../images/coin.svg';

import ScoreTableRow from './ScoreTable2pRow';
import Player2PositionScore from './Player2PositionScore';
import EndResultPules from '../EndResultModal/EndResultPules2p';
import EndResultFines from '../EndResultModal/EndResultFines2p';
import * as constants from '../../../../constants/constants';
import { getBetValue } from '../../../../common/services/data-service';
import { renderNum } from '../../../../utils/stringUtils';


class ScoreTable extends React.Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    player1ShortName: PropTypes.string,
    player2ShortName: PropTypes.string,
    player1Uid: PropTypes.string,
    player2Uid: PropTypes.string,
    points: PropTypes.shape(),
    totalPnts: PropTypes.shape({
      player1: PropTypes.number,
      player2: PropTypes.number,
    }),
    myPos: PropTypes.string,
    scoreTableOpen: PropTypes.bool,
    party: PropTypes.number,
    bet: PropTypes.string,
    fetchPartyLog: PropTypes.func,
    isEndResultTable: PropTypes.bool,
    closeReason: PropTypes.shape(),
    gameType: PropTypes.string,
    showInfoModal: PropTypes.func.isRequired,
    fontMode: PropTypes.string,
    isInAppFrame: PropTypes.bool,
  };

  static defaultProps = {
    player1ShortName: null,
    player2ShortName: null,
    player1Uid: null,
    player2Uid: null,
    points: {},
    totalPnts: {},
    myPos: null,
    scoreTableOpen: true,
    party: null,
    bet: null,
    fetchPartyLog: null,
    isEndResultTable: false,
    closeReason: null,
    gameType: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      scrollPos: 0,
      pPlues: {
        player1: 0,
        player2: 0,
        player3: 0,
        player4: 0,
      },
    };
  }

  componentDidMount() {
    this.scrollToBottom();
  }

  shouldComponentUpdate(nextProps) {
    if (!isEqual(nextProps, this.props)) {
      this.scrollToBottom();
      return true;
    }

    // if (nextProps.privatePules !== privatePules) {
    //   fetchPules();
    // }
    return false;

    /*  const {
      points,
      //  players,
      player1ShortName,
      player2ShortName,
      totalPnts,
      scoreTableOpen,
      myPos,
    } = nextProps;
    const {
      points: curPoints,
      //  players: curPlayers,
      player1ShortName: curPlayer1ShortName,
      player2ShortName: curPlayer2ShortName,
      myPos: curMyPos,
      totalPnts: curTotalPoints,
      scoreTableOpen: curScoreTableOpen,
    } = this.props;
    if (points) {
      if (Object.keys(points).length) {
        if (Object.keys(points).length !== Object.keys(curPoints).length) {
          return true;
        }
      }
    }

    //  if (players && Object.keys(players).length !== Object.keys(curPlayers).length) {
    //    return true;
    //  }

    if (!curPlayer1ShortName && player1ShortName) {
      return true;
    }

    if (!curPlayer2ShortName && player2ShortName) {
      return true;
    }

    if (!curMyPos && myPos) {
      return true;
    }

    if (!curTotalPoints && totalPnts) {
      return true;
    }

    if (curTotalPoints && totalPnts && (totalPnts.player1 !== curTotalPoints.player1
      || totalPnts.player2 !== curTotalPoints.player2)) {
      return true;
    }

    if (curScoreTableOpen !== scoreTableOpen) {
      return true;
    }

    return false;  */
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutID);
  }

  scrollToBottom = () => {
    if (this.pointsScrollbar) {
      this.timeoutID = setTimeout(() => {
        if (this.pointsScrollbar) {
          this.pointsScrollbar.scrollBottom();
        }
      }, 20);
    }
  };

  setLastRef = (el) => {
    this.lastRef = el;
  };

  updateScrollPos = (val) => {
    this.setState({ scrollPos: val.topPosition || 0 });
  }

  scroll = (newVal) => {
    this.pointsScrollbar.scrollYTo(newVal);
  }

  fetchPartyLog = (party, pulesTitle) => {
    const { fetchPartyLog, isEndResultTable } = this.props;

    if (fetchPartyLog && isEndResultTable) {
      fetchPartyLog(party, pulesTitle);
    }
  }

  renderPoints = (key, index) => {
    const {
      points,
      player1ShortName,
      player2ShortName,
      myPos,
      party,
      //  fetchPartyLog,
      isEndResultTable,
      gameType
    } = this.props;

    return (
      <tr
        key={key}
        className={`score-table-row ${(index + 1) === size(points) && points[key].id === '-' && isEndResultTable ? 'pules-delimiter-line' : ''}`}
        ref={(el) => {
          if (party === index + 2) {
            this.lastRef = el;
          }
        }}
      >
        <ScoreTableRow
          player1={points[key].player1}
          player2={points[key].player2}
          pule={points[key].pule}
          player1ShortName={player1ShortName || ''}
          player2ShortName={player2ShortName || ''}
          myPos={myPos}
          index={points[key].id || null}
          roundIndex={index}
          isEndResultTable={isEndResultTable}
          fetchPartyLog={this.fetchPartyLog}
          roundSize={size(points)}
          pulesTitle={(index + 1) === size(points) && points[key].id === '-' && isEndResultTable ? 'pules-delimiter-line' : ''}
          gameType={gameType}
        />
      </tr>
    );
  };

  renderMissedRound = () => {
    const {
      player1Uid,
      player2Uid,
      //  points,
      player1ShortName,
      player2ShortName,
      myPos,
      party,
      //  fetchPartyLog,
      isEndResultTable,
      closeReason,
      gameType
    } = this.props;

    if (closeReason && closeReason.playerUid) {
    //  const { playerUid } = closeReason;

      return (
        <tr
          key="missed-row"
          className="score-table-row"
          ref={(el) => { this.lastRef = el; }}
        >
          <ScoreTableRow
            player1={closeReason.playerUid === player1Uid ? -16 : 4}
            player2={closeReason.playerUid === player2Uid ? -16 : 4}
            pule={null}
            player1ShortName={player1ShortName || ''}
            player2ShortName={player2ShortName || ''}
            myPos={myPos}
            index="-"
            roundIndex={party - 1}
            isEndResultTable={isEndResultTable}
            fetchPartyLog={this.fetchPartyLog}
            gameType={gameType}
          />
        </tr>
      );
    }
    return null;
  };

  render() {
    const {
      t,
      player1ShortName,
      player2ShortName,
      totalPnts,
      points,
      myPos,
      scoreTableOpen,
      bet,
      isEndResultTable,
      gameType,
      closeReason,
      showInfoModal,
      players,
      globalParams,
      fontMode,
      isInAppFrame,
    } = this.props;
    const { scrollPos } = this.state;

    let betRatio;

    if (bet) {
      betRatio = parseInt(bet.replace('1:', ''), 10);
    }
    const pPules = [];
    if (points) {
      map(points, (item, key) => {
        if (item.pule) {
          // console.log(item.pule, "result pule");
          const puleType = item.pule;
          if (puleType !== constants.COMMON_PULE.p || puleType !== constants.COMMON_PULE._p) {
            pPules.push(puleType);
          }
        }
      });
    }

    return (
      <div className={`score-table ${!scoreTableOpen ? 'score-table-hidden' : ''}`}>
        <table className="full-width header-full">
          <colgroup>
            <col span="1" className="" />
          </colgroup>
          <thead className="full-width score-table-header-for-pules">
            <tr>
              <th className="score-table-id-header width-10">#</th>
              <Player2PositionScore myPos={myPos} playerPules={pPules} player1ShortName={player1ShortName} player2ShortName={player2ShortName} />

              {gameType && gameType.includes('P') && (
                <th className="score-table-pules-header width-15">
                  <div className="score-table-header-player">
                    {t('pules')}
                  </div>
                  <div className="plues-section">
                    {
                      // pPules && map(filter(pPules, (pule) => { return pule === 'P-' || pule === 'P'; }), item => (
                        pPules && map(filter(pPules, (pule) => { return pule === 'P'; }), item => (
                        <div className='under-pules' />
                      ))
                    }
                  </div>
                </th>
              )}
              {isEndResultTable ? (
                <th className="score-table-info-header" />
              ) : (null)}
            </tr>
          </thead>
          <tbody />
        </table>
        <div className="score-table-scroll-area-wrapper end-result-socre-table-modal">
          <ScrollAreaButtons
            scrollPos={scrollPos}
            show={this.pointsScrollbar && this.pointsScrollbar.state && this.pointsScrollbar.state.realHeight >= this.pointsScrollbar.state.containerHeight ? true : null}
            scroll={this.scroll}
            speed={30}
            rightOffset={-1}
            topOffset={-1}
            bottomOffset={-1}
            bgColor="#2d191a"
          />
          <ScrollArea
            speed={0.55}
            className={`aaaa4 score-table-scroll-area ${isInAppFrame && 'score-table-scroll-area-iframe'}`}
            contentClassName="score-table-scroll-content"
            verticalContainerStyle={{
              background: 'transparent',
              opacity: 1,
              width: 11,
              marginRight: 2,
            }}
            verticalScrollbarStyle={{
              background: '#fff',
              borderRadius: 1,
              width: 10,
            }}
            minScrollSize={25}
            horizontal={false}
            onScroll={this.updateScrollPos}
            ref={(el) => {
              this.pointsScrollbar = el;
            }}
          >
            <table style={{ width: '100%' }}>
              <thead />
              <tbody>
                {points && Object.keys(points).map(this.renderPoints)}
                {/* {(isEndResultTable && closeReason && (closeReason.reason === 'leftRoom') && !closeReason.isAutomated) ? (
                  <>
                    {this.renderMissedRound()}
                  </>
                ) : (null)} */}
              </tbody>
            </table>
          </ScrollArea>
        </div>
        <div className={isEndResultTable ? 'score-table-bottom-wrapper' : ''}>
          <table className="score-table-points">
            <thead />
            <tbody style={{ width: '100%' }}>
              <tr>
                <th className="score-table-points-col-id">
                  <div>{t('points')}</div>
                </th>
                <th className="score-table-points-col">
                  <>
                    {myPos === 'player1' && (
                      <>{(totalPnts && totalPnts.player2 ? renderNum(totalPnts.player2) : 0)}</>
                    )}
                    {myPos === 'player2' && (
                      <>{(totalPnts && totalPnts.player1 ? renderNum(totalPnts.player1) : 0)}</>
                    )}
                  </>
                </th>
                <th className="score-table-points-col">
                  <>
                    {myPos === 'player1' && (
                      <>{(totalPnts && totalPnts.player1 ? renderNum(totalPnts.player1) : 0)}</>
                      )}
                    {myPos === 'player2' && (
                      <>{(totalPnts && totalPnts.player2 ? renderNum(totalPnts.player2) : 0)}</>
                      )}
                  </>
                </th>

                {gameType && gameType.includes('P') && (
                  <th className="score-table-points-col-pules" style={{width: '18%', maxWidth: '38px', minWidth: '38px'}} />
                )}

              </tr>
            </tbody>
          </table>
          <table className="score-table-sum">
            <thead />
            <tbody style={{ width: '100%' }}>
              <tr>
                <th className="score-table-sum-col-id">
                  <div>
                    <Media src={coinImg} className="player-balance-coin" />
                  </div>
                </th>
                <th className="score-table-points-col">
                  <>
                    {myPos === 'player1' && (
                      <>
                        {totalPnts && totalPnts.player2 && betRatio
                          ? renderNum(betRatio * totalPnts.player2)
                          : 0}
                      </>
                    )}
                    {myPos === 'player2' && (
                      <>
                        {totalPnts && totalPnts.player1 && betRatio
                          ? renderNum(betRatio * totalPnts.player1)
                          : 0}
                      </>
                    )}
                  </>
                </th>
                <th className="score-table-points-col">
                  <>
                    {myPos === 'player1' && (
                      <>
                        {totalPnts && totalPnts.player1 && betRatio
                          ? renderNum(betRatio * totalPnts.player1)
                          : 0}
                      </>
                    )}
                    {myPos === 'player2' && (
                      <>
                        {totalPnts && totalPnts.player2 && betRatio
                          ? renderNum(betRatio * totalPnts.player2)
                          : 0}
                      </>
                    )}
                  </>
                </th>
                {gameType && gameType.includes('P') && (
                  <th className="score-table-sum-col-pules" style={{width: '18%', maxWidth: '38px', minWidth: '38px'}} />
                )}
              </tr>
            </tbody>
          </table>
          {isEndResultTable ? (
            <>
              {gameType && gameType.includes('P') ? (
                <EndResultPules t={t} betRatio={betRatio} fontMode={fontMode} />
              ) : null}
              {closeReason && closeReason.reason && (closeReason.reason === 'missedTurn' || closeReason.reason === 'leftRoom') ? (
                <EndResultFines t={t} showInfoModal={showInfoModal} />
              ) : null}
            </>
          ) : (null)}
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state, ownProps) => {
  if (state.game) {
    return ({
      // myPos: state.game.myPos || null,
      globalParams: state.game.globalParams || {},
      players: state.game.players,
    });
  }
  return null;
};

export default connect(mapStateToProps, null)(withTranslation('game')(ScoreTable));